import { render, staticRenderFns } from "./createEntityFromExcel.vue?vue&type=template&id=71d8a96d"
import script from "./createEntityFromExcel.vue?vue&type=script&lang=js"
export * from "./createEntityFromExcel.vue?vue&type=script&lang=js"
import style0 from "./createEntityFromExcel.vue?vue&type=style&index=0&id=71d8a96d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports